/**
 *
 * v.1.0  10/09/25  Inicial
 * v.1.1  11/09/25  Añadido componentDidUpdate
 * v.1.2  24/07/26  Añadido contador de caracteres y límite visual
 */

import React from 'react';
import PropTypes from 'prop-types';

class InputTextArea extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            valor: props.valor || "",
            hasFocus: false
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.valor !== this.props.valor) {
            this.setState({
                valor: this.props.valor?.toString() || ""
            });
        }
    }

    handleChange = (e) => {
        this.setState({
            valor: e.target.value
        });
    }

    handleFocus = () => {
        this.setState({
            hasFocus: true
        });
    }

    handleBlur = () => {
        this.setState({
            hasFocus: false
        });

        if (this.props.onChange) {
            this.props.onChange(this.state.valor);
        }
    }

    render() {

        const { valor, hasFocus } = this.state;

        const {
            className,
            numRows,
            maxCaracteres,
            warningFrom,
            showCounter,
            style,
            ...rest
        } = this.props;

        const longitud = valor.length;

        const hayLimite = maxCaracteres > 0;

        const restantes = hayLimite
            ? maxCaracteres - longitud
            : 0;

        const excedido = hayLimite && restantes < 0;

        let colorContador = "#777";

        if (hayLimite) {
            if (excedido) {
                colorContador = "#d32f2f";
            } else if (restantes <= warningFrom) {
                colorContador = "#f57c00";
            }
        }

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%"
                }}
            >
                <textarea
                    {...rest}
                    className={className}
                    value={valor}
                    rows={numRows}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    style={{
                        ...style,
                        width: "100%",
                        boxSizing: "border-box",
                        border: excedido
                            ? "1px solid #d32f2f"
                            : style?.border
                    }}
                />

                {showCounter && hasFocus && hayLimite && (
                    <div
                        style={{
                            marginTop: 3,
                            fontSize: "11px",
                            textAlign: "right",
                            color: colorContador
                        }}
                    >
                        {excedido
                            ? `${-restantes} caracteres de más`
                            : `${restantes} caracteres restantes`}
                    </div>
                )}
            </div>
        );
    }
}

InputTextArea.propTypes = {
    className: PropTypes.string,
    valor: PropTypes.string,
    onChange: PropTypes.func,
    numRows: PropTypes.number,

    // Número máximo recomendado de caracteres.
    // No impide escribir más, solo informa visualmente.
    maxCaracteres: PropTypes.number,

    // Cuando queden warningFrom caracteres o menos,
    // el contador pasa a color naranja.
    warningFrom: PropTypes.number,

    // Mostrar u ocultar el contador.
    showCounter: PropTypes.bool,

    // Estilo del textarea.
    style: PropTypes.object
};

InputTextArea.defaultProps = {
    valor: "",
    numRows: 3,
    maxCaracteres: 255,
    warningFrom: 240,
    showCounter: true,
    style: {}
};

export default InputTextArea;